import { ApiResponse, ApisauceInstance } from 'apisauce';

const getUploadDataTypes = (
  api: ApisauceInstance,
): Promise<ApiResponse<DataManager.UploadDataType[]>> =>
  api.get<DataManager.UploadDataType[]>('/v1/uploads');

export default getUploadDataTypes;
